var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44446 8.33306L10 2.77778L15.5556 8.33306",
    stroke: "#C691FB",
    strokeWidth: 1.11111
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44446 11.6667L10 17.222L15.5556 11.6667",
    stroke: "#C691FB",
    strokeWidth: 1.11111
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdown);
export default __webpack_public_path__ + "static/media/updown.541d4821c6cabeb9f04774555260e7fb.svg";
export { ForwardRef as ReactComponent };